// src/components/HowItWorksContent.js
import React from 'react';
import styles from './HowItWorksContent.module.css';
import { CheckCircle, ChevronRight, Crown } from 'lucide-react';

// Add the goToSignUp prop here
const HowItWorksContent = ({ goToSignUp }) => {
  return (
    <div className={styles.howItWorksContainer}>
      <h2 className={styles.mainTitle}>How Linkist Works</h2>
      
      <div className={styles.stepContainer}>
        <div className={styles.stepNumber}>1</div>
        <div className={styles.stepContent}>
          <h3 className={styles.stepTitle}>SIGN UP</h3>
          <ul className={styles.featureList}>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Create a free account in seconds</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Choose your custom username</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Get your personal Linkist URL (linkist.se/yourusername)</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Upload a profile picture</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Upload a banner</li>
          </ul>
        </div>
      </div>
      
      <div className={styles.stepContainer}>
        <div className={styles.stepNumber}>2</div>
        <div className={styles.stepContent}>
          <h3 className={styles.stepTitle}>ADD YOUR LINKS</h3>
          <ul className={styles.featureList}>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Add up to 5 links (Free) or 25 links (Pro)</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Select icons for each platform</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Customize with your brand colors</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Choose from multiple themes</li>
          </ul>
        </div>
      </div>
      
      <div className={styles.stepContainer}>
        <div className={styles.stepNumber}>3</div>
        <div className={styles.stepContent}>
          <h3 className={styles.stepTitle}>SHARE WITH THE WORLD</h3>
          <ul className={styles.featureList}>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Share on social media and in your bio</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Use the QR code for in-person networking</li>
            <li><CheckCircle size={16} className={styles.checkIcon} /> Track clicks with analytics (Pro)</li>
          </ul>
        </div>
      </div>
      
      <div className={styles.proContainer}>
        <div className={styles.proHeader}>
          <Crown size={18} className={styles.crownIcon} />
          <h3 className={styles.proTitle}>PRO BENEFITS</h3>
        </div>
        <div className={styles.proGrid}>
          <div className={styles.proFeature}>
            <ChevronRight size={14} className={styles.arrowIcon} />
            <span>More links and icons (up to 25)</span>
          </div>
          <div className={styles.proFeature}>
            <ChevronRight size={14} className={styles.arrowIcon} />
            <span>Priority link placement</span>
          </div>
          <div className={styles.proFeature}>
            <ChevronRight size={14} className={styles.arrowIcon} />
            <span>Custom icon colors</span>
          </div>
          <div className={styles.proFeature}>
            <ChevronRight size={14} className={styles.arrowIcon} />
            <span>Profile banner upload</span>
          </div>
          <div className={styles.proFeature}>
            <ChevronRight size={14} className={styles.arrowIcon} />
            <span>Ghost Mode for private links</span>
          </div>
          <div className={styles.proFeature}>
            <ChevronRight size={14} className={styles.arrowIcon} />
            <span>Click tracking & analytics</span>
          </div>
        </div>
        <div className={styles.proPrice}>
          <span>Just €3/month</span>
        </div>
      </div>
      
      <div className={styles.getStartedContainer}>
        {/* Change to use the goToSignUp prop function instead of window.location */}
        <button className={styles.getStartedButton} onClick={goToSignUp}>
          Get Started Now
        </button>
      </div>
    </div>
  );
};

export default HowItWorksContent;